import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import { Grid, Chip } from '@mui/material';
import { useState } from 'react';
import { WsButton, WsColors } from 'wisestep-base';

interface CandidateTagsProps {
  tags: string[];
  initialLimit?: number;
  isNotes?: boolean;
}

const CandidateTags = ({ tags = [], initialLimit = 2, isNotes = false }: CandidateTagsProps) => {
  const [displayLimit, setDisplayLimit] = useState(initialLimit);

  return (
    <>
      {tags.slice(0, displayLimit).map((tag, index) => (
        <Grid item key={index}>
          <Chip
            icon={<SellOutlinedIcon fontSize="small" />}
            style={{
              borderRadius: 4,
              backgroundColor: isNotes ? WsColors.BorderGrey : WsColors.White,
            }}
            label={tag}
            size="small"
          />
        </Grid>
      ))}
      {tags.length > initialLimit && (
        <Grid item>
          <WsButton
            variant="text"
            size="medium"
            onClick={() =>
              setDisplayLimit(displayLimit === tags.length ? initialLimit : tags.length)
            }
          >
            {displayLimit < tags.length ? `+ ${tags.length - displayLimit} more` : 'show less'}
          </WsButton>
        </Grid>
      )}
    </>
  );
};

export default CandidateTags;
